<template>
  <riepilogo-eventi-component :utente="utente" :key="keyListaEventi" :titoloEvento="titoloEvento" :pathEventResource="pathEventResource" :linkEvent="linkEvent"></riepilogo-eventi-component>
</template>

<script>
import RiepilogoEventiComponent from "../components/RiepilogoEventiComponent.vue";
import UtilityMixins from "../../../../utility/UtilityMixin";
export default {
  mixins: [UtilityMixins],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  components: {
    RiepilogoEventiComponent,
  },

  watch: {
    utente: function () {
      this.keyListaEventi++;
    },
  },
  mounted() {},
  data() {
    return {
      titoloEvento: "Riepilogo Eventi",
      pathEventResource: "/cardioanamnesi",
      keyListaEventi: 0,
      linkEvent: "/paziente/cardiologia/anamnesi",
    };
  },
};
</script>

<style></style>
